import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "popup-header popup-header--details" }
const _hoisted_2 = { class: "popup-header-main" }
const _hoisted_3 = { class: "popup-header-texts" }
const _hoisted_4 = { class: "popup-header-title" }
const _hoisted_5 = { class: "popup-header-meta" }
const _hoisted_6 = { class: "details-container" }
const _hoisted_7 = { class: "stats-grid" }
const _hoisted_8 = { class: "stat-card stat-card--revenue" }
const _hoisted_9 = { class: "stat-content" }
const _hoisted_10 = { class: "stat-value" }
const _hoisted_11 = { class: "stat-card stat-card--owner" }
const _hoisted_12 = { class: "stat-content" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = { class: "info-sections-grid" }
const _hoisted_15 = { class: "info-column" }
const _hoisted_16 = { class: "info-section-card" }
const _hoisted_17 = { class: "info-list" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "info-item" }
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "info-item" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "info-section-card" }
const _hoisted_25 = { class: "info-list" }
const _hoisted_26 = { class: "info-item" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "info-item" }
const _hoisted_29 = { class: "value highlight" }
const _hoisted_30 = { class: "info-item" }
const _hoisted_31 = { class: "value" }
const _hoisted_32 = { class: "info-column" }
const _hoisted_33 = { class: "info-section-card" }
const _hoisted_34 = { class: "info-list" }
const _hoisted_35 = { class: "info-item" }
const _hoisted_36 = { class: "value multiline" }
const _hoisted_37 = { class: "info-item" }
const _hoisted_38 = { class: "value multiline" }
const _hoisted_39 = { class: "info-item" }
const _hoisted_40 = { class: "value multiline" }
const _hoisted_41 = { class: "info-section-card" }
const _hoisted_42 = { class: "info-list" }
const _hoisted_43 = { class: "info-item" }
const _hoisted_44 = { class: "value" }
const _hoisted_45 = { class: "info-item" }
const _hoisted_46 = { class: "value success" }
const _hoisted_47 = { class: "system-meta-card" }
const _hoisted_48 = { class: "meta-row" }
const _hoisted_49 = { class: "meta-item" }
const _hoisted_50 = { class: "meta-item" }
const _hoisted_51 = {
  ref: "popupBody",
  class: "popup-body-simple popup-body-modern"
}
const _hoisted_52 = { class: "form-content form-content-modern" }
const _hoisted_53 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_54 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_55 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_56 = { class: "footer-right" }
const _hoisted_57 = { class: "popup-body-modern" }
const _hoisted_58 = {
  class: "show-more-container",
  style: {"display":"flex","justify-content":"center","margin":"1px 0"}
}
const _hoisted_59 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_60 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_61 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_62 = { class: "form-footer footer-modern" }
const _hoisted_63 = {
  class: "footer-right",
  style: {"margin-top":"1px","text-align":"right"}
}
const _hoisted_64 = { class: "popup-body-modern" }
const _hoisted_65 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_66 = { class: "form-footer footer-fixed footer-modern" }
const _hoisted_67 = {
  class: "footer-right",
  style: {"margin-top":"10px","text-align":"right"}
}
const _hoisted_68 = { class: "popup-body-simple popup-body-modern" }
const _hoisted_69 = { class: "form-content form-content-modern" }
const _hoisted_70 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_71 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_72 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_73 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_74 = { class: "footer-fixed footer-modern" }
const _hoisted_75 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_dx_button = _resolveComponent("dx-button")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxTexts = _resolveComponent("DxTexts")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxScrollView = _resolveComponent("DxScrollView")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!
  const _component_DxLabel = _resolveComponent("DxLabel")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxForm = _resolveComponent("DxForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGrid",
      allowColumnReordering: true,
      "data-source": {
      store: _ctx.dsSales,
      filter: _ctx.gridFilter
    },
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnResizingMode: 'nextColumn',
      "remote-operations": true,
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-row-lines": true,
      "show-column-lines": false,
      allowMerging: 'Cells',
      height: "100%",
      class: "grid theme-dependent",
      onExporting: _ctx.onExporting,
      onRowClick: _ctx.onRowClick
    }, {
      accountCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxDropDownBox, {
          "data-source": _ctx.dsParteneri,
          "value-expr": "ID",
          "display-expr": _ctx.displayCompanie,
          value: data.value,
          opened: _ctx.isAccountDdbOpen,
          "onUpdate:opened": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isAccountDdbOpen) = $event)),
          "show-clear-button": true
        }, {
          content: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsParteneri,
              "key-expr": "ID",
              columns: ['Nume'],
              height: "100%",
              onSelectionChanged: e => {
              const id = e.selectedRowKeys?.[0] ?? null;
              data.setValue(id);
              _ctx.isAccountDdbOpen = false;
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelection, { mode: "single" })
              ]),
              _: 1
            }, 8, ["data-source", "onSelectionChanged"])
          ]),
          _: 2
        }, 1032, ["data-source", "display-expr", "value", "opened"])
      ]),
      proiectCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxSelectBox, {
          "data-source": _ctx.dsProiecte,
          value: data.value,
          "value-expr": "Id",
          "display-expr": "Cod",
          "search-enabled": true,
          onValueChanged: (e) => data.setValue(e.value)
        }, null, 8, ["data-source", "value", "onValueChanged"])
      ]),
      industrieCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxDropDownBox, {
          "data-source": _ctx.dsIndustrii,
          "value-expr": "ID",
          "display-expr": "Nume",
          value: data.value,
          opened: _ctx.isIndustrieDdbOpen,
          "onUpdate:opened": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isIndustrieDdbOpen) = $event)),
          "show-clear-button": true
        }, {
          content: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsIndustrii,
              "key-expr": "ID",
              columns: ['Nume'],
              height: "100%",
              onSelectionChanged: e => {
              const id = e.selectedRowKeys?.[0] ?? null;
              data.setValue(id);
              _ctx.isIndustrieDdbOpen = false;
            }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelection, { mode: "single" })
              ]),
              _: 1
            }, 8, ["data-source", "onSelectionChanged"])
          ]),
          _: 2
        }, 1032, ["data-source", "value", "opened"])
      ]),
      campanieCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxDropDownBox, {
          "data-source": _ctx.dsCampaniiMarketing,
          "value-expr": "ID",
          "display-expr": "Denumire",
          value: data.value,
          opened: _ctx.isCampanieDdbOpen,
          "onUpdate:opened": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isCampanieDdbOpen) = $event)),
          "show-clear-button": true
        }, {
          content: _withCtx(() => [
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.dsCampaniiMarketing,
              "key-expr": "ID",
              columns: ['Denumire'],
              height: "100%",
              onSelectionChanged: e => {
                const id = e.selectedRowKeys?.[0] ?? null;
                data.setValue(id);
                _ctx.isCampanieDdbOpen = false;
              }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxSelection, { mode: "single" })
              ]),
              _: 1
            }, 8, ["data-source", "onSelectionChanged"])
          ]),
          _: 2
        }, 1032, ["data-source", "value", "opened"])
      ]),
      valutaCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxSelectBox, {
          "data-source": _ctx.dsValuta,
          value: data.value,
          "value-expr": "Id",
          "display-expr": "Nume",
          "search-enabled": true,
          onValueChanged: (e) => data.setValue(e.value)
        }, null, 8, ["data-source", "value", "onValueChanged"])
      ]),
      sursaCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxSelectBox, {
          "data-source": _ctx.dsSalesSources,
          value: data.value,
          "value-expr": "ID",
          "display-expr": "Nume",
          "search-enabled": true,
          onValueChanged: (e) => data.setValue(e.value)
        }, null, 8, ["data-source", "value", "onValueChanged"])
      ]),
      statusCellEditor: _withCtx(({ data }) => [
        _createVNode(_component_DxSelectBox, {
          "data-source": _ctx.dsStatus,
          value: data.value,
          "value-expr": "ID",
          "display-expr": "Nume",
          "search-enabled": true,
          onValueChanged: (e) => data.setValue(e.value)
        }, null, 8, ["data-source", "value", "onValueChanged"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxScrolling, { mode: 'virtual' }),
        _createVNode(_component_DxColumnChooser, {
          enabled: true,
          "allow-search": true,
          title: "Selector coloane"
        }),
        _createVNode(_component_DxPaging, { "page-size": 20 }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxLoadPanel, { "show-pane": false }),
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": true,
          formats: ['xlsx', 'pdf']
        }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, { location: "before" }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  class: "continue-application",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToOpportunities && _ctx.goToOpportunities(...args)))
                }, [...(_cache[41] || (_cache[41] = [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", { class: "folder" }, [
                      _createElementVNode("div", { class: "top" }, [
                        _createElementVNode("svg", { viewBox: "0 0 24 27" }, [
                          _createElementVNode("path", { d: "M0 0h24v27H0z" })
                        ])
                      ]),
                      _createElementVNode("div", { class: "paper" })
                    ]),
                    _createElementVNode("div", { class: "pencil" })
                  ], -1),
                  _createTextVNode(" Vezi pagina de oportunități ", -1)
                ]))])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_dx_button, {
                    icon: "plus",
                    type: "success",
                    onClick: _ctx.onAddClick,
                    hint: "Adauga Oportunitate"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_DxButton, {
                    icon: "refresh",
                    onClick: _ctx.onRefreshClick,
                    hint: "Reimprospateaza"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "exportButton",
              hint: "Exporta"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "separator" })
                ], -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "columnChooserButton",
              "locate-in-menu": "auto",
              hint: "Alege Coloanele"
            }),
            _createVNode(_component_DxGridToolbarItem, {
              name: "searchPanel",
              "locate-in-menu": "auto"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxTexts, {
          "group-continued-message": "Continuat de pe pagina anterioara",
          "group-continues-message": "Continuat pe pagina urmatoare"
        }),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          filterValue: false,
          savingTimeout: 100,
          "storage-key": "gridCardOportunitatiState"
        }),
        _createVNode(_component_DxColumn, { "data-field": "Titlu" }),
        _createVNode(_component_DxColumn, {
          "data-field": "Contact.Nume",
          visible: false,
          caption: "Nume Contact"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Account.Nume",
          visible: false,
          caption: "Partener"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "AccountID",
          visible: false,
          "show-in-column-chooser": false,
          "edit-cell-template": 'accountCellEditor'
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Sursa",
          visible: false,
          caption: "Sursă"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Proiect.Nume",
          visible: false,
          caption: "Proiect"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ProiectID",
          visible: false,
          "show-in-column-chooser": false,
          "edit-cell-template": 'proiectCellEditor'
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "IntervalCumparare",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "BugetEstimat",
          visible: false,
          caption: "Buget Estimat"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Note",
          visible: false,
          caption: "Note"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cerere",
          visible: false,
          caption: "Cerere"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Oferta",
          visible: false,
          caption: "Ofertă"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataInchidereEstimat",
          visible: false,
          caption: "Închidere Estimată"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "VenitEstimat",
          visible: false,
          caption: "Venit Estimat"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Owner",
          caption: "Responsabil"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "VenitRealizat",
          visible: false,
          caption: "Venit Realizat"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataInchis",
          visible: false,
          caption: "Data Închidere"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "UltimulStatus",
          visible: false,
          caption: "Ultimul Status"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Industrie.Nume",
          visible: false,
          caption: "Industrie"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "IndustrieID",
          visible: false,
          "show-in-column-chooser": false,
          "edit-cell-template": 'industrieCellEditor'
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Campanie.Nume",
          visible: false,
          caption: "Campanie"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CampanieID",
          visible: false,
          "show-in-column-chooser": false,
          "edit-cell-template": 'campanieCellEditor'
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CostEstimat",
          visible: false,
          caption: "Cost Estimat"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CostEfectiv",
          visible: false,
          caption: "Cost Efectiv"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ListaProduse",
          visible: false,
          caption: "Produse"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cod",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Valuta.Nume",
          visible: false,
          caption: "Valuta"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValutaID",
          visible: false,
          "show-in-column-chooser": false,
          "edit-cell-template": 'valutaCellEditor'
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Curs",
          visible: false,
          caption: "Curs"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Sursa.Nume",
          visible: false,
          caption: "Sursa"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "SursaID",
          visible: false,
          "show-in-column-chooser": false,
          "edit-cell-template": 'sursaCellEditor'
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Data",
          visible: false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Status.Nume",
          caption: "Status"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "StatusID",
          visible: false,
          "show-in-column-chooser": false,
          "edit-cell-template": 'statusCellEditor'
        }),
        _createVNode(_component_DxColumn, {
          type: "buttons",
          "visible-index": 9999,
          "allow-reordering": false,
          "allow-resizing": false,
          width: "90",
          buttons: [
          {
            hint: 'Vezi detalii',
            icon: 'info',
            onClick: _ctx.onViewDetails
          },
          'edit',
          {
            name: 'delete',
            visible: (e) => {
              return _ctx.isOwner(e.row.data.Owner);
            }
          }
        ]
        }, null, 8, ["buttons"])
      ]),
      _: 1
    }, 8, ["data-source", "onExporting", "onRowClick"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isOpportunityDetailsVisible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isOpportunityDetailsVisible) = $event)),
      "drag-enabled": false,
      "hide-on-outside-click": true,
      "show-close-button": true,
      width: 750,
      height: 700
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "popup-header-icon dx-icon-info" }, null, -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.selectedOpportunity.Titlu || 'Detalii Oportunitate'), 1),
              _cache[44] || (_cache[44] = _createElementVNode("div", { class: "popup-header-subtitle" }, "Document de analiză comercială", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(['status-chip', 'status-chip--' + _ctx.getStatusClass(_ctx.selectedOpportunity.Status)])
            }, _toDisplayString(_ctx.selectedOpportunity.Status || 'Status necunoscut'), 3)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxScrollView, {
          width: "100%",
          height: "100%",
          class: "details-scroll-view"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[47] || (_cache[47] = _createElementVNode("div", { class: "stat-icon dx-icon-money" }, null, -1)),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[46] || (_cache[46] = _createElementVNode("div", { class: "stat-label" }, "Venit Estimat", -1)),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatCurrency(_ctx.selectedOpportunity.VenitEstimat, _ctx.selectedOpportunity.Valuta)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "stat-icon dx-icon-user" }, null, -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "stat-label" }, "Responsabil", -1)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.selectedOpportunity.Owner || '-'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-group section-icon" }),
                      _createElementVNode("span", null, "Informații Generale")
                    ], -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[50] || (_cache[50] = _createElementVNode("label", null, "Contact Principal", -1)),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.selectedOpportunity.Contact || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _cache[51] || (_cache[51] = _createElementVNode("label", null, "Sursa", -1)),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.selectedOpportunity.Sursa || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[52] || (_cache[52] = _createElementVNode("label", null, "Industrie", -1)),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.selectedOpportunity.Industrie || '-'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-event section-icon" }),
                      _createElementVNode("span", null, "Planificare")
                    ], -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _cache[54] || (_cache[54] = _createElementVNode("label", null, "Data Creării", -1)),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.formatDate(_ctx.selectedOpportunity.Data)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _cache[55] || (_cache[55] = _createElementVNode("label", null, "Închidere Estimată", -1)),
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formatDate(_ctx.selectedOpportunity.DataInchidereEstimat)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[56] || (_cache[56] = _createElementVNode("label", null, "Interval Cumpărare", -1)),
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.selectedOpportunity.IntervalCumparare || '-'), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _cache[61] || (_cache[61] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-folder section-icon" }),
                      _createElementVNode("span", null, "Detalii Business")
                    ], -1)),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _cache[58] || (_cache[58] = _createElementVNode("label", null, "Cerere / Nevoie", -1)),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.selectedOpportunity.Cerere || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _cache[59] || (_cache[59] = _createElementVNode("label", null, "Oferta Propsă", -1)),
                        _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.selectedOpportunity.Oferta || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _cache[60] || (_cache[60] = _createElementVNode("label", null, "Explicație / Note", -1)),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.selectedOpportunity.Note || '-'), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "section-header" }, [
                      _createElementVNode("span", { class: "dx-icon-box section-icon" }),
                      _createElementVNode("span", null, "Analiză Financiară")
                    ], -1)),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _cache[62] || (_cache[62] = _createElementVNode("label", null, "Buget Estimat", -1)),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.formatCurrency(_ctx.selectedOpportunity.BugetEstimat, _ctx.selectedOpportunity.Valuta)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _cache[63] || (_cache[63] = _createElementVNode("label", null, "Venit Realizat", -1)),
                        _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.formatCurrency(_ctx.selectedOpportunity.VenitRealizat,
                      _ctx.selectedOpportunity.Valuta)), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _cache[66] || (_cache[66] = _createElementVNode("span", { class: "dx-icon-edit meta-icon" }, null, -1)),
                    _createElementVNode("span", null, [
                      _cache[65] || (_cache[65] = _createTextVNode("Creat de ", -1)),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.selectedOpportunity.UserCreat || 'Sistem'), 1),
                      _createTextVNode(" la " + _toDisplayString(_ctx.formatDate(_ctx.selectedOpportunity.DataCreat, true)), 1)
                    ])
                  ]),
                  _cache[68] || (_cache[68] = _createElementVNode("div", { class: "meta-separator" }, null, -1)),
                  _createElementVNode("div", _hoisted_50, [
                    _cache[67] || (_cache[67] = _createElementVNode("span", { class: "dx-icon-refresh meta-icon" }, null, -1)),
                    _createElementVNode("span", null, "Ultima modificare: " + _toDisplayString(_ctx.formatDate(_ctx.selectedOpportunity.DataModificat, true)), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      showTitle: true,
      height: 615,
      width: 1350
    }, {
      title: _withCtx(() => [...(_cache[69] || (_cache[69] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare oportunitate"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează informațiile în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nouă ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createVNode(_component_DxForm, {
              formData: _ctx.formData,
              "col-count": 2,
              "col-span": 2
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItem, {
                  "item-type": "group",
                  caption: _ctx.tabs[0],
                  "col-count": 2,
                  "css-class": "form-section-simple form-section-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxFormItem, {
                      dataField: "Titlu",
                      "css-class": "field-full-width",
                      "col-span": 2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Denumire Oportunitate" }),
                        _createVNode(_component_DxRequiredRule, { message: "Denumirea este obligatorie" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      label: { text: 'Status' },
                      "col-span": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownBox, {
                          value: _ctx.sStatus,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sStatus) = $event)),
                          "data-source": _ctx.dsStatus,
                          "display-expr": "Nume",
                          "value-expr": "ID",
                          "show-clear-button": true,
                          placeholder: "Nou",
                          "content-template": "gridContent",
                          "read-only": true
                        }, {
                          gridContent: _withCtx(() => [
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_component_DxDataGrid, {
                                "data-source": _ctx.dsStatus,
                                "hover-state-enabled": true,
                                height: 280,
                                "remote-operations": true,
                                onRowClick: _ctx.onStatusRowClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxPaging, {
                                    enabled: true,
                                    "page-size": 5
                                  }),
                                  _createVNode(_component_DxFilterRow, { visible: true }),
                                  _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                  _createVNode(_component_DxSorting, { mode: "single" }),
                                  _createVNode(_component_DxColumn, {
                                    "data-field": "NrOrd",
                                    visible: false,
                                    "sort-order": "asc",
                                    "sort-index": 0
                                  }),
                                  _createVNode(_component_DxColumn, {
                                    "data-field": "Nume",
                                    caption: "Status"
                                  }),
                                  _createVNode(_component_DxColumn, {
                                    "data-field": "Pondere",
                                    caption: "Pondere (%)",
                                    width: "120"
                                  })
                                ]),
                                _: 1
                              }, 8, ["data-source", "onRowClick"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["value", "data-source"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Owner",
                      "editor-options": { readOnly: true },
                      "col-span": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Responsabil" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      label: { text: 'Partener' },
                      "col-span": 1
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Partenerul este obligatoriu" }),
                        _createVNode(_component_DxDropDownBox, {
                          value: _ctx.sPartener,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sPartener) = $event)),
                          opened: _ctx.isParteneriGridBoxOpened,
                          "onUpdate:opened": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isParteneriGridBoxOpened) = $event)),
                          "data-source": _ctx.dsParteneri,
                          "display-expr": "Nume",
                          "value-expr": "ID",
                          "show-clear-button": true,
                          placeholder: "Selectează partener",
                          "content-template": "gridContent",
                          "read-only": true,
                          "drop-down-options": { width: 500, height: 400 }
                        }, {
                          gridContent: _withCtx(() => [
                            _createElementVNode("div", _hoisted_54, [
                              _createVNode(_component_DxDataGrid, {
                                "data-source": _ctx.dsParteneri,
                                columns: ['Nume'],
                                "hover-state-enabled": true,
                                height: 280,
                                "remote-operations": true,
                                onRowClick: _ctx.onPartenerRowClick
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                  _createVNode(_component_DxFilterRow, { visible: true }),
                                  _createVNode(_component_DxPaging, {
                                    enabled: true,
                                    "page-size": 5
                                  }),
                                  _createVNode(_component_DxSearchPanel, {
                                    visible: true,
                                    placeholder: "Caută..."
                                  }),
                                  _createVNode(_component_DxGridToolbar, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_DxButton, {
                                            icon: "plus",
                                            type: "success",
                                            height: "25px",
                                            width: "25px",
                                            onClick: _ctx.onAddNewPartener
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data-source", "onRowClick"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["value", "opened", "data-source"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, { label: { text: 'Persoană de Contact' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Persoana de contact este obligatorie" }),
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isContacteGridBoxOpened,
                          "onUpdate:opened": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isContacteGridBoxOpened) = $event)),
                          "data-source": _ctx.contactSelectat,
                          value: _ctx.sContact,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sContact) = $event)),
                          "show-clear-button": true,
                          "display-expr": "FullName",
                          "value-expr": "ID",
                          placeholder: "Selectează contact",
                          "drop-down-options": { width: 650, height: 400 },
                          "read-only": true
                        }, {
                          content: _withCtx(({ data }) => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsContacts,
                              "selected-row-keys": _ctx.sContact ? [_ctx.sContact] : [],
                              "hover-state-enabled": true,
                              height: "100%",
                              onSelectionChanged: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onValueSelectedContact($event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Caută..."
                                }),
                                _createVNode(_component_DxColumn, {
                                  "data-field": "Nume",
                                  caption: "Nume"
                                }),
                                _createVNode(_component_DxColumn, {
                                  "data-field": "Prenume",
                                  caption: "Prenume"
                                }),
                                _createVNode(_component_DxGridToolbar, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          icon: "plus",
                                          type: "success",
                                          height: "25px",
                                          width: "25px",
                                          onClick: _ctx.onAddNewContact
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "selected-row-keys"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      "data-field": "Data",
                      "editor-type": "dxDateBox",
                      "col-span": 1,
                      "editor-options": {
                type: 'datetime',
                displayFormat: 'dd/MM/yyyy ',
                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ',
                useMaskBehavior: true
              }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Data " })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "SursaID",
                      editorType: 'dxSelectBox',
                      "editor-options": {
                displayExpr: 'Nume',
                valueExpr: 'ID',
                dataSource: _ctx.dsSalesSources,
                placeholder: 'Selectează',
                showClearButton: true
              }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule, { message: "Sursa lead este obligatorie" }),
                        _createVNode(_component_DxLabel, { text: "Sursă Lead" })
                      ]),
                      _: 1
                    }, 8, ["editor-options"])
                  ]),
                  _: 1
                }, 8, ["caption"]),
                _createVNode(_component_DxFormItem, {
                  "item-type": "group",
                  caption: _ctx.tabs[3],
                  "col-span": 3,
                  "col-count": 3,
                  "css-class": "form-section-simple form-section-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxFormItem, {
                      dataField: "BugetEstimat",
                      editorType: "dxNumberBox",
                      "editor-options": {
                format: '#0.00',
                showSpinButtons: true
              }
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "ProbabilitateCastig",
                      editorType: "dxSelectBox",
                      label: { text: 'Șansa de Câștig (%)' },
                      "editor-options": {
                  dataSource: _ctx.probabilityList,
                  placeholder: 'Selectează %',
                  showClearButton: true
                }
                    }, null, 8, ["editor-options"]),
                    _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isValutaGridBoxOpened,
                          "onUpdate:opened": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isValutaGridBoxOpened) = $event)),
                          "data-source": _ctx.valutaSelectat,
                          value: _ctx.sValuta,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.sValuta) = $event)),
                          "show-clear-button": true,
                          "display-expr": "Simbol",
                          "value-expr": "Id",
                          placeholder: "RON"
                        }, {
                          content: _withCtx(({ data }) => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsValuta,
                              "selected-row-keys": _ctx.sValuta ? [_ctx.sValuta] : [],
                              columns: ['Simbol'],
                              "hover-state-enabled": true,
                              height: "100%",
                              onSelectionChanged: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onValueSelectedOpportunityValuta($event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Caută..."
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "selected-row-keys"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      "data-field": "IntervalCumparare",
                      "editor-type": "dxSelectBox",
                      "editor-options": {
                dataSource: _ctx.intervalList,
                valueExpr: 'name',
                displayExpr: 'name',
                searchEnabled: true,
                placeholder: 'Necunoscut',
                showClearButton: true
              }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Interval Cumpărare" })
                      ]),
                      _: 1
                    }, 8, ["editor-options"]),
                    _createVNode(_component_DxFormItem, {
                      dataField: "DataInchidereEstimat",
                      editorType: "dxDateBox",
                      "editor-options": {
                displayFormat: 'dd/MM/yyyy',
                dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ'
              }
                    }),
                    _createVNode(_component_DxFormItem, {
                      label: { text: 'Campanie' },
                      "col-span": 2
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxDropDownBox, {
                          opened: _ctx.isCampaniiGridBoxOpened,
                          "onUpdate:opened": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isCampaniiGridBoxOpened) = $event)),
                          "data-source": _ctx.campanieSelectat,
                          value: _ctx.sCampanie,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.sCampanie) = $event)),
                          "show-clear-button": true,
                          "display-expr": "Denumire",
                          "value-expr": "ID",
                          placeholder: "Selectează campanie",
                          "drop-down-options": { width: 450 }
                        }, {
                          content: _withCtx(({ data }) => [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsCampaniiMarketing,
                              "selected-row-keys": _ctx.sCampanie ? [_ctx.sCampanie] : [],
                              columns: ['Denumire'],
                              "hover-state-enabled": true,
                              height: 300,
                              onSelectionChanged: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onValueSelectedCampanie($event)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxSelection, { mode: "single" }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxSearchPanel, {
                                  visible: true,
                                  placeholder: "Cauta ..."
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "selected-row-keys"])
                          ]),
                          _: 1
                        }, 8, ["opened", "data-source", "value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_DxFormItem, {
                      dataField: "Note",
                      "editor-type": "dxTextArea",
                      "editor-options": { height: 100 },
                      "col-span": 3
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxLabel, { text: "Observații" })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["caption"])
              ]),
              _: 1
            }, 8, ["formData"])
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                disabled: !_ctx.sPartener,
                onClick: _ctx.onSaveAdd
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ])
          ])
        ], 512)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isPartnerModalVisible,
      width: 1450,
      height: 684,
      "show-title": true,
      title: "Adăugare Partener Nou",
      onHiding: _cache[25] || (_cache[25] = ($event: any) => (_ctx.isPartnerModalVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[70] || (_cache[70] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare partener"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile partenerului ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_57, [
          _createVNode(_component_DxForm, {
            "form-data": _ctx.newPartnerData,
            "col-count": 3,
            "col-span": 3
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Identitate & Fiscal",
                "col-count": 6,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CUI",
                    label: { text: 'CUI/CNP' },
                    "editor-options": _ctx.cuiOptions,
                    "col-span": 3
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Nume",
                    "col-span": 3
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Fiscal",
                    "editor-type": "dxSelectBox",
                    "col-span": 4,
                    label: { text: 'Tip Fiscal' },
                    "editor-options": {
                dataSource: _ctx.dsParteneriFiscal,
                displayExpr: 'Nume',
                valueExpr: 'Cod',
                placeholder: 'Selectează Tip Fiscal',
              }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Câmpul 'Tip Fiscal' este obligatoriu" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Numar",
                    label: { text: 'Regim Comerț' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Caen",
                    label: { text: 'Cod CAEN' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Owner",
                    "editor-options": { readOnly: true },
                    label: { text: 'Responsabil' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Cont",
                    label: { text: 'IBAN' },
                    "col-span": 2
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Memo",
                    "col-span": 6,
                    "editor-options": { height: 80 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Sediu Social",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Strada",
                    "col-span": 3
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Numarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Bloc",
                    "col-span": 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Scarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Et",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Ap",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Localitate",
                    "col-span": 3
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Adresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Domiciliu Fiscal",
                "col-span": 1,
                "col-count": 4,
                "css-class": "form-section-simple form-section-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CStrada",
                    "col-span": 3,
                    label: { text: 'Strada' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CNumarstrada",
                    "col-span": 1,
                    label: { text: 'Nr.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CBloc",
                    "col-span": 1,
                    label: { text: 'Bl.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CScarabloc",
                    "col-span": 1,
                    label: { text: 'Sc.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CEt",
                    "col-span": 1,
                    label: { text: 'Etaj' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CAp",
                    "col-span": 1,
                    label: { text: 'Ap.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CLocalitate",
                    "col-span": 3,
                    label: { text: 'Localitate' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CCP",
                    "col-span": 1,
                    label: { text: 'C.P.' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CAdresa",
                    "col-span": 4,
                    "editor-type": "dxTextArea",
                    "editor-options": { height: 80 },
                    label: { text: 'Adresă Completă' }
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "col-count": 3,
                "col-span": 3
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_DxButton, {
                      "element-attr": { class: 'show-more-btn' },
                      text: _ctx.showExtendedDetails ? 'Ascunde detalii suplimentare' : 'Completează detalii suplimentare',
                      icon: _ctx.showExtendedDetails ? 'chevronup' : 'chevrondown',
                      type: "normal",
                      "styling-mode": "text",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showExtendedDetails = !_ctx.showExtendedDetails))
                    }, null, 8, ["text", "icon"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Configurare Financiară & Comericală",
                visible: _ctx.showExtendedDetails,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, { label: { text: 'Bancă (Internă)' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        value: _ctx.sBanci,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.sBanci) = $event)),
                        "data-source": _ctx.dsBanci,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează bancă",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 200 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsBanci,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: _ctx.onBanciRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" }),
                                _createVNode(_component_DxGridToolbar, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_DxButton, {
                                          icon: "plus",
                                          type: "success",
                                          height: "25px",
                                          width: "25px",
                                          onClick: _ctx.onAddNewBank
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onRowClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        opened: _ctx.isPartnerValutaGridBoxOpened,
                        "onUpdate:opened": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.isPartnerValutaGridBoxOpened) = $event)),
                        "data-source": _ctx.valutaSelectat,
                        value: _ctx.sValuta,
                        "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.sValuta) = $event)),
                        "show-clear-button": true,
                        "display-expr": "Simbol",
                        "value-expr": "Id",
                        placeholder: "RON"
                      }, {
                        content: _withCtx(({ data }) => [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsValuta,
                            "selected-row-keys": _ctx.sValuta ? [_ctx.sValuta] : [],
                            columns: ['Simbol'],
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onValueSelectedPartnerValuta($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "selected-row-keys"])
                        ]),
                        _: 1
                      }, 8, ["opened", "data-source", "value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, { "data-field": "CapitalSocial" }),
                  _createVNode(_component_DxFormItem, { "data-field": "CifraAfacere" }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Grup' },
                    "col-span": 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        value: _ctx.sGrupuri,
                        "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.sGrupuri) = $event)),
                        "data-source": _ctx.dsGrupuri,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează ",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 400 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_60, [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsGrupuri,
                              columns: ['Nume'],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: _ctx.onGrupuriRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onRowClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    label: { text: 'Zona' },
                    "col-span": 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxDropDownBox, {
                        value: _ctx.sZona,
                        "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.sZona) = $event)),
                        "data-source": _ctx.dsZona,
                        "display-expr": "Nume",
                        "value-expr": "Id",
                        "show-clear-button": true,
                        placeholder: "Selectează ",
                        "content-template": "gridContent",
                        "drop-down-options": { width: 200 }
                      }, {
                        gridContent: _withCtx(() => [
                          _createElementVNode("div", _hoisted_61, [
                            _createVNode(_component_DxDataGrid, {
                              "data-source": _ctx.dsZona,
                              columns: [
                      { dataField: 'Nume', caption: 'Nume' }
                    ],
                              "hover-state-enabled": true,
                              height: 280,
                              "remote-operations": true,
                              onRowClick: _ctx.onZonaRowClick
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DxPaging, {
                                  enabled: true,
                                  "page-size": 5
                                }),
                                _createVNode(_component_DxFilterRow, { visible: true }),
                                _createVNode(_component_DxScrolling, { mode: "virtual" })
                              ]),
                              _: 1
                            }, 8, ["data-source", "onRowClick"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["value", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AdaosPret",
                    "col-span": 1
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Scadenta",
                    "col-span": 1
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "Contacte & Diverse",
                visible: _ctx.showExtendedDetails,
                "col-count": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Tel",
                    label: { text: 'Telefon' }
                  }),
                  _createVNode(_component_DxFormItem, { "data-field": "Fax" }),
                  _createVNode(_component_DxFormItem, { "data-field": "Email" }),
                  _createVNode(_component_DxFormItem, { "data-field": "Director" }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Observatii",
                    "col-span": 2,
                    "editor-options": { height: 100 },
                    "editor-type": "dxTextArea"
                  })
                ]),
                _: 1
              }, 8, ["visible"]),
              _createVNode(_component_DxFormItem, {
                "item-type": "group",
                caption: "System Flags",
                visible: _ctx.showExtendedDetails,
                "col-count": 2,
                "col-span": 2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AplicaTVAlaIncasare",
                    "editor-type": "dxCheckBox",
                    label: { text: 'TVA la Încasare' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "AplicaTvaDefalcat",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Split TVA' }
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "RegimSpecialTVA",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Client",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Furnizor",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Activ",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Litigiu",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "ExternUE",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "Extern",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "faraScadenta",
                    "editor-type": "dxCheckBox"
                  }),
                  _createVNode(_component_DxFormItem, {
                    "data-field": "CalculezPenalitati",
                    "editor-type": "dxCheckBox"
                  })
                ]),
                _: 1
              }, 8, ["visible"])
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_DxButton, {
                text: "Salvează Compania",
                type: "success",
                onClick: _ctx.onSaveNewPartner,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.isPartnerModalVisible = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isBankModalVisible,
      width: 800,
      height: 550,
      "show-title": true,
      title: "Adăugare Bancă",
      onHiding: _cache[28] || (_cache[28] = ($event: any) => (_ctx.isBankModalVisible = false))
    }, {
      title: _withCtx(() => [...(_cache[71] || (_cache[71] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare bancă"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile băncii ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_64, [
          _createVNode(_component_DxForm, {
            "form-data": _ctx.newBankData,
            "col-count": 2,
            "col-span": 2
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, { "data-field": "Ordine" }),
              _createVNode(_component_DxFormItem, { "data-field": "Cod" }),
              _createVNode(_component_DxFormItem, { "data-field": "Nume" }),
              _createVNode(_component_DxFormItem, { label: { text: 'Valută' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxDropDownBox, {
                    value: _ctx.sValute,
                    "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.sValute) = $event)),
                    "data-source": _ctx.dsValute,
                    "display-expr": "Nume",
                    "value-expr": "Id",
                    "show-clear-button": true,
                    placeholder: "Selectează ",
                    "content-template": "gridContent"
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_DxDataGrid, {
                          "data-source": _ctx.dsValute,
                          columns: ['Nume'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: _ctx.onValuteRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxPaging, {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_component_DxFilterRow, { visible: true }),
                            _createVNode(_component_DxScrolling, { mode: "virtual" })
                          ]),
                          _: 1
                        }, 8, ["data-source", "onRowClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "data-source"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, { "data-field": "CodIBAN" }),
              _createVNode(_component_DxFormItem, { "data-field": "CodBIC" }),
              _createVNode(_component_DxFormItem, { "data-field": "CodSWIFT" }),
              _createVNode(_component_DxFormItem, { "data-field": "TextFC" }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Principala",
                "editor-type": "dxCheckBox"
              }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Activ",
                "editor-type": "dxCheckBox"
              })
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_component_DxButton, {
                text: "Salvează Banca",
                type: "success",
                onClick: _ctx.onSaveNewBank,
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.isBankModalVisible = false)),
                height: "32px",
                width: "200px",
                "styling-mode": "outlined"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isContactModalVisible,
      onHiding: _cache[40] || (_cache[40] = ($event: any) => (_ctx.isContactModalVisible = false)),
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 800,
      height: 560
    }, {
      title: _withCtx(() => [...(_cache[72] || (_cache[72] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare contact"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează detaliile contactului în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nou ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_component_DxForm, {
              "form-data": _ctx.contactData,
              "col-count": 3,
              "col-span": 3,
              "label-alignment": "center",
              ref: "form"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxFormItem, {
                  "data-field": "Nume",
                  "col-span": 1,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul Nume este obligatoriu" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Prenume",
                  "col-span": 1,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Câmpul Prenume este obligatoriu" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Titlu",
                  label: { text: 'Funcția' },
                  "col-span": 1,
                  "col-count": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Funcția este obligatorie" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Partener' },
                  "col-span": 2,
                  "col-count": 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Partenerul este obligatoriu" }),
                    _createVNode(_component_DxDropDownBox, {
                      value: _ctx.sContactPartener,
                      "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.sContactPartener) = $event)),
                      opened: _ctx.isContactPartenerGridBoxOpened,
                      "onUpdate:opened": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.isContactPartenerGridBoxOpened) = $event)),
                      "data-source": _ctx.dsParteneri,
                      "display-expr": "Nume",
                      "value-expr": "ID",
                      "show-clear-button": true,
                      placeholder: "Selectează partener",
                      "content-template": "gridContent"
                    }, {
                      gridContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_70, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsParteneri,
                            columns: ['Nume'],
                            "hover-state-enabled": true,
                            height: 280,
                            "remote-operations": true,
                            onRowClick: _ctx.onContactPartenerRowClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxScrolling, { mode: "virtual" }),
                              _createVNode(_component_DxGridToolbar, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_DxButton, {
                                        icon: "plus",
                                        type: "success",
                                        height: "25px",
                                        width: "25px",
                                        onClick: _ctx.onAddNewPartener
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "onRowClick"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["value", "opened", "data-source"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "MetodaContact",
                  label: { text: 'Metodă Contact' },
                  "editor-type": "dxSelectBox",
                  "editor-options": {
                items: _ctx.metodaContact,
                placeholder: 'Selectează metoda de contact'
              }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxRequiredRule, { message: "Metoda de contact este obligatorie" })
                  ]),
                  _: 1
                }, 8, ["editor-options"]),
                _createVNode(_component_DxFormItem, {
                  "data-field": "TelMobil",
                  label: { text: 'Telefon' },
                  "is-required": _ctx.contactData.MetodaContact === 'Telefonic'
                }, null, 8, ["is-required"]),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Email",
                  label: { text: 'Email' },
                  "is-required": _ctx.contactData.MetodaContact === 'Email'
                }, null, 8, ["is-required"]),
                _createVNode(_component_DxFormItem, {
                  dataField: "Adresa",
                  label: { text: 'Adresă' },
                  "col-span": 3
                }),
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Țară' },
                  "col-span": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      "data-source": _ctx.dsTari,
                      value: _ctx.sContactTara,
                      "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.sContactTara) = $event)),
                      opened: _ctx.isContactTaraGridBoxOpened,
                      "onUpdate:opened": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.isContactTaraGridBoxOpened) = $event)),
                      "show-clear-button": true,
                      "display-expr": "Nume",
                      "value-expr": "ID",
                      placeholder: "Selectează țara",
                      "content-template": "gridContent"
                    }, {
                      gridContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsTari,
                            columns: ['Nume'],
                            "remote-operations": true,
                            "selected-row-keys": _ctx.sContactTara ? [_ctx.sContactTara] : [],
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onContactValueSelectedTara($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută ..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "selected-row-keys"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "opened"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, { label: { text: 'Județ' } }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      opened: _ctx.isContactJudetGridBoxOpened,
                      "onUpdate:opened": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.isContactJudetGridBoxOpened) = $event)),
                      value: _ctx.sContactJudet,
                      "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.sContactJudet) = $event)),
                      "show-clear-button": true,
                      "display-expr": "Nume",
                      "value-expr": "ID",
                      placeholder: "Selectează județul"
                    }, {
                      content: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsJudete,
                            columns: ['Nume'],
                            "selected-row-keys": _ctx.sContactJudet ? [_ctx.sContactJudet] : [],
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onContactValueSelectedJudet($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută ..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "selected-row-keys"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["opened", "value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  label: { text: 'Localitate' },
                  "col-span": 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxDropDownBox, {
                      "data-source": _ctx.dsLocalitati,
                      value: _ctx.sContactLocalitate,
                      "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.sContactLocalitate) = $event)),
                      opened: _ctx.isContactLocalitateGridBoxOpened,
                      "onUpdate:opened": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.isContactLocalitateGridBoxOpened) = $event)),
                      "show-clear-button": true,
                      "display-expr": "Localitate",
                      "value-expr": "ID",
                      placeholder: "Selectează localitatea",
                      "content-template": "gridContent"
                    }, {
                      gridContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_73, [
                          _createVNode(_component_DxDataGrid, {
                            "data-source": _ctx.dsLocalitati,
                            columns: ['Localitate'],
                            "remote-operations": true,
                            "selected-row-keys": _ctx.sContactLocalitate ? [_ctx.sContactLocalitate] : [],
                            "hover-state-enabled": true,
                            height: "100%",
                            onSelectionChanged: _cache[37] || (_cache[37] = ($event: any) => (_ctx.onContactValueSelectedLocalitate($event)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DxSelection, { mode: "single" }),
                              _createVNode(_component_DxPaging, {
                                enabled: true,
                                "page-size": 5
                              }),
                              _createVNode(_component_DxFilterRow, { visible: true }),
                              _createVNode(_component_DxSearchPanel, {
                                visible: true,
                                placeholder: "Caută ..."
                              })
                            ]),
                            _: 1
                          }, 8, ["data-source", "selected-row-keys"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["data-source", "value", "opened"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxFormItem, {
                  "data-field": "Note",
                  "col-span": 3,
                  "editor-options": { height: 80 },
                  "editor-type": "dxTextArea"
                })
              ]),
              _: 1
            }, 8, ["form-data"])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                disabled: !_ctx.contactData.AccountID,
                onClick: _ctx.onSaveAddContact
              }, null, 8, ["disabled", "onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onCancelContact
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}